import { API_URL } from 'core/infra/environment'
import { HttpClient, type HttpClientConfig } from 'core/infra/http/HttpClient'

import { createFacility } from '../domain/Facility'
import { getMainContact } from '../domain/FacilityContact'
import { FacilityRepository } from '../infra/FacilityRepository'

type getFacilityInformationFactoryDeps = {
  repository: FacilityRepository
}

export function getFacilityInformationFactory({ repository }: getFacilityInformationFactoryDeps) {
  return async function getFacility(uuid: string, options?: Partial<HttpClientConfig>) {
    try {
      const [facility, performance, hours, contacts, report] = await Promise.all([
        repository.getFacilityById(uuid, options),
        repository.getFacilityPerformance(uuid, options),
        repository.getFacilityHours(uuid, options),
        repository.getFacilityContacts(uuid, options),
        repository.getFacilityReportById(uuid, options),
      ])
      const contact = getMainContact(contacts)

      return createFacility(facility, performance, hours, contact, report)
    } catch (error) {
      throw new Error('Failed to fetch facility information', { cause: error })
    }
  }
}

export function getFacilityInformation(uuid: string, options?: Partial<HttpClientConfig>) {
  const httpClient = new HttpClient(API_URL)
  const repository = new FacilityRepository({ httpClient })
  const get = getFacilityInformationFactory({ repository })

  return get(uuid, options)
}
